import { render, staticRenderFns } from "./AStaffDetailInspection.vue?vue&type=template&id=00da03b3&scoped=true"
import script from "./AStaffDetailInspection.vue?vue&type=script&lang=js"
export * from "./AStaffDetailInspection.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailInspection.vue?vue&type=style&index=0&id=00da03b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da03b3",
  null
  
)

export default component.exports